"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Leg = () => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "8", height: "5", viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M0 0V2.76772C0 4.21783 1.77351 4.92116 2.76736 3.86519L5.45681 1.00765C6.06097 0.365738 6.90294 0.00127805 7.7843 3.35493e-06C5.30942 2.53165e-06 2.69058 1.4328e-06 0 0Z", fill: "#E44258" }) })));
Leg.displayName = "Leg";
exports.default = Leg;
